export const CONTENT_LANGUAGE_HEADER = 'x-unity-content-language' as const;
